import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import {setAuthToken} from '../helpers/authHelper';
import { USER_HASH_EXPIRED, FETCH_USER_OBJECT, FETCH_USER_IDENTITY_DATA, FETCH_USER_TYPE_DETAILS } from '../actions/userDataActions';
import { setPilotId } from '../helpers/userHelper.js';
import { GLOBAL_EVENTS } from '../constants/common.js';

export function fetchUserInformation(uuid, adminAuthToken){
  let requestConfig = {};
  if (adminAuthToken) {
    requestConfig = {
      handlerEnabled: false,
      headers: {Authorization: `Bearer ${adminAuthToken}`}
    }
  }
  return dispatch => {
    return axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/users/' + uuid, requestConfig).then(
      (response) => {
        let payload = response.data.payload;
        payload.pilotId && setPilotId(payload.pilotId);
        dispatch({
          type: FETCH_USER_OBJECT,
          payload: payload
        })
      }
    )
  }
}

export function fetchUserHash(uuid, pilotId){
  return axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/user-auth/cipher', {
    params: {
      'user-id': uuid,
      'pilot-id': pilotId
    }
  }).then(
    (response) => {
      return response.data.payload;
    }
  )
}

export function fetchUserIdentityData(userHash,options, adminAuthToken) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/user-auth/' + userHash , {
      params : options,
      handlerEnabled : false
    }).then(
      (response) => {
        setAuthToken(response.data.payload.tokenDetails.access_token);
        dispatch(fetchUserInformation(response.data.payload.userCipherDetails.userId, adminAuthToken)).then(() => {
          dispatch({
            type: FETCH_USER_IDENTITY_DATA,
            payload: response.data.payload
          });
        });
      },
      (error) => {
          dispatch({
            type: USER_HASH_EXPIRED
          });
      }
    )
  }
}

export function fetchUserTypeDetails(userId) { 
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/users/' + userId + '/consumption-data-summary', {
      params: {
        templateName: GLOBAL_EVENTS.FETCH_CONSUMPTION_DATA_SUMMARY
      }
    }).then( 
    (response)=> { 
      dispatch({ 
          type: FETCH_USER_TYPE_DETAILS, 
          payload : response.data.payload 
        }) 
      } 
    )
  }  
}